import { render } from "./SoundCreature.vue?vue&type=template&id=0ace98f6&scoped=true"
import script from "./SoundCreature.vue?vue&type=script&lang=js"
export * from "./SoundCreature.vue?vue&type=script&lang=js"

import "./SoundCreature.vue?vue&type=style&index=0&id=0ace98f6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ace98f6"]])

export default __exports__